import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './es/es'
import en from './en.json'
import LanguageDetector from 'i18next-browser-languagedetector'
function requiredString(value: string, key: unknown, options: unknown, translator: unknown) {
  return `${value} *`;
}
export default i18next
  .use({
    type: "postProcessor",
    name: "required",
    process: requiredString,
  })
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false // react ya se encarga de esto
    },
    resources: {
      es: {
        translation: es,
      },
      en: {
        translation: en,
      },
    },
    fallbackLng: 'es',
  })
